import React, { Component } from 'react';
import { BrowserRouter as Router, Redirect, Route } from 'react-router-dom';
import 'typeface-roboto';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import './App.css';
import Home from '../Home/Home';
import SendPage from '../SendPage/SendPage';
import PageStatus from '../PageStatus/PageStatus';
import Login from '../Login/Login';
import Loading from '../Loading/Loading';
import Recipients from '../Recipients/Recipients';
import ImportRecipients from '../ImportRecipients/ImportRecipients';
import Recipient from '../Recipient/Recipient';
import RecentPages from '../RecentPages/RecentPages';
import Responses from '../Responses/Responses';
import Users from '../Users/Users';
import User from '../User/User';
import { auth } from '../../utilities/firebase-config';
import firebaseConfig from '../../utilities/firebase-config.temp';

const overrides = {
  MuiDialog: {
    paper: {
      margin: 12,
    },
  },
};

// Use a different app bar color depending on environment
if (firebaseConfig.projectId.indexOf('staging') !== -1) {
  overrides.MuiAppBar = {
    colorPrimary: {
      backgroundColor: '#f44336',
      color: '#fff',
    },
  };
}

const theme = createMuiTheme({
  overrides,
});

class App extends Component {
  state = {
    user: undefined,
  };

  componentDidMount() {
    auth.onAuthStateChanged((user) => {
      const setUser = (fbUser) => {
        this.setState({ user: fbUser });
      };

      if (!user) {
        // If launching from a PWA, don't need the delay for showing loading view because
        // the splashscreen already did that.
        if (navigator.standalone) {
          setUser(user);
        } else {
          setTimeout(() => {
            setUser(user);
          }, 1500);
        }
      } else {
        setUser(user);
      }
    });
  }

  chooseRoute = () => {
    const { user } = this.state;
    switch (user) {
      case undefined:
        return <Loading />;
      case null:
        return <Login />;
      default:
        return <Redirect to="/home" />;
    }
  };

  render() {
    return (
      <MuiThemeProvider theme={ theme }>
        <Router>
          <div>
            <Route
              exact
              path="/"
              render={ () => this.chooseRoute() }
            />
            <Route path="/home" component={ Home } />
            <Route path="/send-page" component={ SendPage } />
            <Route path="/page-status" component={ PageStatus } />
            <Route path="/login" component={ Login } />
            <Route path="/recipients" component={ Recipients } />
            <Route path="/recipient" component={ Recipient } />
            <Route path="/import-recipients" component={ ImportRecipients } />
            <Route path="/recent-pages" component={ RecentPages } />
            <Route path="/responses" component={ Responses } />
            <Route path="/users" component={ Users } />
            <Route path="/user" component={ User } />
          </div>
        </Router>
      </MuiThemeProvider>
    );
  }
}

export default App;
